import React from "react"
import echarts from "echarts"

import "./VisitorFlow.less"
import DataShop from "../../../data/shop"
import Util from "../../../util/util"
import Loading from "../../../components/Loading"

function dataFormat(data) {
  if (data.length) {
    return data
  }
  var value = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
  ]
  for (var key in data) {
    value[key] = data[key]
  }
  return value
}
// 客流趋势
class VisitorFlow extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      report: {},
    }
  }

  componentDidMount() {
    this.getData()
  }

  componentWillUnmount() {
    Util.destroyCharts(this.chart)
  }

  getData() {
    let { id, date } = this.props
    DataShop.getVisitorFlow(id, date).then((res) => {
      let data = res.data || {}
      this.setState({ report: data.report || {}, vdata: data.vdata || {} })
      this.renderChart()
    })
  }

  renderChart() {
    let vdata = this.state.vdata

    let datas = [
      {
        name: "昨日客流",
        data: dataFormat(vdata.yd),
      },
      {
        name: "前日客流",
        data: dataFormat(vdata.byd),
      },
    ]
    if (vdata.td) {
      datas.push({
        name: "今日客流",
        data: dataFormat(vdata.td),
      })
    }
    let xAxisNames = vdata.series || [
      "00",
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
    ]
    // setPassTitle (data.report);
    var option = {
      backgroundColor: "#1F1C40",
      tooltip: {
        trigger: "axis",
      },
      legend: {
        right: "3%",
        top: 0,
        itemGap: 16,
        data: datas.map((d) => {
          return { name: d.name }
        }),
        textStyle: {
          color: "#a8aab0",
          fontStyle: "normal",
          fontFamily: "微软雅黑",
          fontSize: 10,
        },
      },
      color: ["#574BF1", "#1B87F4", "#F03599"],
      grid: {
        top: 50,
        bottom: 30,
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        axisLabel: {
          formatter: "{value}",
          color: "#8c939b",
        },
        data: xAxisNames,
        axisLine: {
          show: true,
        },
        axisTick: {
          show: true,
          inside: true,
        },
      },
      yAxis: {
        type: "value",
        axisLabel: {
          formatter: "{value}",
          color: "#8c939b",
        },
        axisLine: {
          show: true,
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          lineStyle: {
            color: ["#333"],
          },
        },
      },
      series: datas.map((d) => {
        return {
          name: d.name,
          type: "line",
          data: d.data,
          symbolSize: 8,
        }
      }),
    }
    var chart = (this.chart = echarts.init(
      document.getElementById("chartFlow")
    ))
    chart.setOption(option)
    Util.registerChartsResize(chart)
  }

  render() {
    let { report } = this.state
    let ratio_change = 0
    let differ = report.yd_num - report.byd_num
    if (report.byd_num && differ) {
      ratio_change = Math.round(
        Math.max(
          1,
          (Math.abs(report.yd_num - report.byd_num) / report.byd_num) * 100
        )
      )
    } else if (report.yd_num && !report.byd_num) {
      ratio_change = 100
    }

    let cname = "icon-font"
    let cname_num = "num"
    if (differ > 0) {
      cname += " icon-asc"
      // cname_num += ' asc'
    } else if (differ < 0) {
      cname += " icon-desc"
      cname_num += " desc"
    }

    return (
      <div className="box-visitor-flow">
        <div className="history-table">
          <div className="history-flow-title flow-three-info">
            <ul>
              <li>
                <span className="num">{report.byd_num}</span>
                <span className="text">前日客流</span>
              </li>
              <li>
                <span className="num" id="yt">
                  {report.yd_num}
                </span>
                <span className="text">昨日客流</span>
              </li>
              <li className="change">
                <span className={cname_num}>
                  <i className={cname} id="icon-change" />
                  <b id="differ">{ratio_change}%</b>
                </span>
                <span className="text">较上一日变化</span>
              </li>
            </ul>
          </div>
          {report.month_total ? (
            <div className="history-flow-title">
              <ul>
                <li>
                  <span className="num" id="month_total">
                    {report.month_total}
                  </span>
                  <span className="text">月总</span>
                </li>
                <li>
                  <span
                    className={"num" + (report.day_new_add < 0 ? " desc" : "")}
                    id="day_new_add"
                  >
                    {report.day_new_add}
                  </span>
                  <span className="text">月增</span>
                </li>
                <li className="change">
                  <span
                    className={"num" + (report.day_mean_add < 0 ? " desc" : "")}
                    id="day_mean_add"
                  >
                    {report.day_mean_add}
                  </span>
                  <span className="text">日均增</span>
                </li>
                <li>
                  <span className="num" id="day_mean">
                    {report.day_mean}
                  </span>
                  <span className="text">月均</span>
                </li>
                <li>
                  <span className="num" id="max_nums">
                    {report.max_nums}
                  </span>
                  <span className="text">日高</span>
                </li>
                <li className="change">
                  <span
                    className={"num" + (report.max_new_add < 0 ? " desc" : "")}
                    id="max_new_add"
                  >
                    {report.max_new_add}
                  </span>
                  <span className="text">日高增</span>
                </li>
              </ul>
            </div>
          ) : null}
        </div>
        <div className="chart-container">
          <h2 className="shop-body-title">
            <i className="icon" />
            <span className="i-title">客流趋势</span>
          </h2>
          <div id="chartFlow">
            <Loading loading={true} />
          </div>
        </div>
      </div>
    )
  }
}

export default VisitorFlow
